import { ScansInfoResponseData } from '@atbay/scan-job-manager-node-sdk'
import { generateToast } from '@components/toasting'
import { ScanJobClient } from '@core/api/scan-job-client'
import { BaseService } from '@core/base/service/base-service'
import { sleep } from '@core/utils/time'

export const ScansService = new (class ScansService extends BaseService {
    private readonly client = ScanJobClient
    private INTERVAL = 1000 * 5
    private EMIT_SCAN_FINISHED_DELAY = 1000 * 8
    private NUM_RETRY_ON_EMPTY_RES = 0

    constructor() {
        super('scans.service')
    }

    public async getScans(delayScan = 0) {
        if (delayScan > 0) {
            await sleep(delayScan)
        }
        let hasPrevScan = false

        const status: TScanStatus[] = ['REQUESTED', 'RUNNING']

        await this.request(
            () => this.client.getAccountScans(this.accountId, status),
            {
                poll: {
                    maxRetries: 100000,
                    delay: this.INTERVAL,
                    shouldStop: async (response, retriesCompleted) => {
                        const hasScans = !!response?.data?.data?.scans?.length

                        if (hasScans) {
                            hasPrevScan = true
                            this.$eventBus.emit('scan_in_progress')
                            return false
                        } else {
                            // if no scans found, stop polling
                            // if amount of retries is greater than 0 = had prev scans, stop polling and emit event scan_finished
                            if (
                                hasPrevScan ||
                                retriesCompleted > this.NUM_RETRY_ON_EMPTY_RES
                            ) {
                                await sleep(this.EMIT_SCAN_FINISHED_DELAY)
                                if (hasPrevScan) {
                                    this.$eventBus.emit('scan_finished')
                                    generateToast({
                                        type: 'success',
                                        data: `Scan successfully completed. You can find the updated information in the My Stance page`,
                                        testId: 'toast-scan-completed',
                                    })
                                }
                                return true
                            }

                            return false
                        }
                    },
                },
            }
        )
    }

    public async getScansInfo() {
        const [error, result] = await this.request(() =>
            this.client.scansInfo(this.accountId)
        )

        if (error) {
            return
        }

        return result?.data.data as ScansInfoResponseData
    }
})()
